export function applyEffects(element) {
  if (!element.dynamic || !element.effects) return element;

  let { value, effects } = element;
  let newEl = { ...element };

  // --- Blink ---
  if (effects.blink?.enabled && value > effects.blink.threshold) {
    newEl.style = { ...(newEl.style || {}), animation: "blink 1s infinite" };
  }

  // --- Color Change ---
  if (effects.colorChange?.threshold !== null) {
    const { threshold, above, below } = effects.colorChange;
    newEl.style = {
      ...(newEl.style || {}),
      color: value >= threshold ? above : below
    };
  }

  // --- Visibility ---
  if (effects.visibility?.enabled) {
    const { threshold } = effects.visibility;
    newEl.style = {
      ...(newEl.style || {}),
      display: value >= threshold ? "block" : "none"
    };
  }

  // --- Size Change ---
  if (effects.sizeChange?.enabled && value >= effects.sizeChange.threshold) {
    const { width, height } = effects.sizeChange;
    newEl.width = width ?? newEl.width;
    newEl.height = height ?? newEl.height;
  }

  // --- Size Proportional ---
  if (effects.sizeProportional?.enabled) {
    const { baseWidth, baseHeight, factorWidth, factorHeight } = effects.sizeProportional;

    if (factorWidth) {
      const base = baseWidth ?? newEl.width;
      newEl.width = base * (value * factorWidth);
    }

    //let value = 1;
    if (factorHeight) {
      const base = baseHeight ?? newEl.height;
      const maxHeight = element.height;

      newEl.height = Math.round(base + (value * factorHeight));
      newEl.top = Math.round((newEl.top || 0) + (maxHeight - newEl.height));
    }
  }

  if (newEl.type === "circle") { 
    const baseColor = element.color || "red";
    newEl.style = { 
        ...(newEl.style || {}),
        background: `radial-gradient(circle, ${baseColor} 0%, rgba(0,0,0,0) 100%)`
    };
}

  return newEl;
}
